export default {
      id: "general-placeholder-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "sprite.svg#general-placeholder",
      toString: function () {
        return this.url;
      }
    }